import { Clickable, Col, Icon, Row, Sidepanel, Text } from 'components';
import { Api, getCost, theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const ImageBackground = styled.div`
  background: url(${(props) => props.source});
  height: ${(props) => (props.small ? 192 : 264)}px;
  width: 192px;
  margin: ${(props) => (props.wide || props.small ? 0 : `-1px`)} 0 0 -1px;
  padding: 12px;
  position: relative;
  background-size: ${(props) => (props.small ? 'contain' : 'cover')};
  background-repeat: no-repeat;
  background-position: center;
  ${(props) => props.small && `border: 2px solid ${theme.GREY_20};`}
`;

const StoreItem = ({ item, favorite, currency, rates, navigate, wide, small }) => {
  const { isMobile } = useSelector((state) => state.appState),
    favorited = useSelector((state) => state.user.favoriteProducts)?.find((y) => y === item._id),
    costInLocal = getCost(rates, 'usd', item.priceInUSD, currency);

  return (
    <Col
      noFlex
      wid={wide ? '100%' : '216px'}
      centerAll={wide}
      ht={small ? '290px' : '376px'}
      border={!small && `2px solid ${theme.GREY_20}`}
      style={{
        boxSizing: 'border-box'
      }}
    >
      <ImageBackground
        wide={wide}
        small={small}
        source={item.media?.length && item.media[0].thumbnail}
      >
        {!!item.discount && (
          <Col noFlex wid="fit-content" bg={theme.SECONDARY} pos="absolute" pad="2px 8px">
            <Text bold col="#fff" c1>
              {-item.discount}%
            </Text>
          </Col>
        )}

        <Row wid="fit-content" pos="absolute" bottom="16px">
          <Clickable onClick={() => favorite(item)} action={`favorite-${item._id}`}>
            <Row
              noFlex
              pad="10px"
              bg={favorited ? theme.SECONDARY : 'rgba(210, 216, 223, 0.7)'}
              hasRadius="32px"
            >
              <Icon type="heart" dimensions={20} col={favorited ? '#fff' : '#000'} />
            </Row>
          </Clickable>
        </Row>
      </ImageBackground>

      <Col between pad={`8px ${small ? 0 : '12px'} 12px`}>
        <Text med wid="192px">
          {item.name}
        </Text>

        <Text>
          {(costInLocal.convertedPrice / 100).toLocaleString(undefined, {
            style: 'currency',
            currency: currency || 'usd'
          }) || 0}
        </Text>
      </Col>
    </Col>
  );
};

const ItemList = ({ data, title, limitless, marg, handleClick, small }) => {
  const [panelVisible, setPanelVisible] = useState(false),
    { currency } = useSelector((state) => state.user.billing),
    { rates } = useSelector((state) => state.appState),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    { t } = useTranslation();

  if (!data?.length) return null;

  async function favorite(item) {
    const res = await Api.post('/store/favorite', { productId: item?._id }, `favorite-${item._id}`);
    if (!res) return;

    dispatch({
      type: 'FAVORITE_PRODUCT',
      payload: item?._id
    });
  }

  return (
    <Col wid="100%" marg={marg || (isMobile ? '16px 0 8px' : '32px 0 8px')}>
      {title && (
        <Row between end pad={isMobile && '0 16px'}>
          <Text h2>{title}</Text>

          {!limitless && data.length > 4 && (
            <Clickable onClick={() => (handleClick ? handleClick() : setPanelVisible(true))}>
              <Text b2 bold>
                {t('common.seeAll')}
              </Text>
            </Clickable>
          )}
        </Row>
      )}

      <Row
        gap="24px"
        marg="16px 0 0"
        wid={isMobile ? 'calc(100vw - 32px)' : '936px'}
        start
        wrapFlex={limitless}
        scrollX={isMobile}
        pad={isMobile && '0 16px'}
      >
        {data.slice(0, limitless || isMobile ? data.length : 4).map((x, i) => (
          <StoreItem
            item={x}
            favorite={favorite}
            key={i}
            currency={currency}
            rates={rates}
            small={small}
          />
        ))}
      </Row>

      <Sidepanel
        visible={panelVisible}
        closeModal={() => setPanelVisible(false)}
        isMobile={isMobile}
        title={
          <Row between center ht={isMobile ? '44px' : '88px'} pad={isMobile ? '16px' : '0 24px'}>
            <Text h2>{title}</Text>
          </Row>
        }
      >
        <Col gap="16px">
          {data.map((x, i) => (
            <StoreItem
              item={x}
              favorite={favorite}
              key={i}
              currency={currency}
              rates={rates}
              wide
            />
          ))}
        </Col>
      </Sidepanel>
    </Col>
  );
};

export default ItemList;
